import HttpBEService from './http-backend-service'
import {AuditEventType, BE_API} from '../data/constants'
import { SettingDataType } from '../store/state-types'
import { ApiRequest } from 'interfaces/api-request.interface'
import { LoggerMetaData } from 'interfaces/logger.interface'

class LandingPageService extends HttpBEService{

    async getSetting(loggerMetaData: LoggerMetaData){
        const apiRequest: ApiRequest = {
            method: 'get',
            endpoint: BE_API.SETTING,
            eventType: AuditEventType.V1_SETTINGS,
        }
        const res = await this.doFetch(apiRequest,loggerMetaData);
        if(res.error) {
            return {error: res.error, data: null}
        }
        return {error: null, data: this.extractData(res.data.data, res.headers) as SettingDataType}
    }

    async getSettingsV2(data:any, loggerMetaData: LoggerMetaData){
        const apiRequest: ApiRequest = {
            method: 'post',
            body: data,
            endpoint: BE_API.SETTING_V2,
            eventType: AuditEventType.V2_SCAN_QR,

        }
       const res = await this.doFetch(apiRequest,loggerMetaData);
       if(res.error) {
        return {error: res.error, data: null}
       }
       return {error: null, data: this.extractData(res.data.data, res.headers, data) as SettingDataType}
    }

    extractData(data:any,headers:any,params?:any){
        const {qrInfo = {},setting,setting:{images,merchant,tipping, payment:{checkoutSetting = {},googlePaySetting = {}, applePaySetting = {}} = {}}} = data
        return {
            merchantName:merchant.name,
            merchantCountryCode:merchant.countryCode,
            posSessionId:qrInfo.posSessionId || '',
            merchantKey:merchant.key,
            tableNo:qrInfo.tableNo || params?.tableNo,
            images:{
                defaultImage:images.defaultImage,
                smartwebLogo:images.smartwebLogo,
                smartwebSplashLoading:images.smartwebSplashLoading,
                smartwebloginScreen:images.smartwebloginScreen
            },
            css:setting.layout.css,
            merchantAddr:merchant.address,
            merchantEmail:merchant.email,
            merchantPhone:merchant.whatsapp,
            currencyDetails:merchant.currencyDetail,
            paymentMappings:merchant.paymentMappings.map((payment:any)=>{
                return {...payment,isValid:true}
            }),
            maxApiChecking:merchant.maxChecking,
            socialMedia:merchant.socialMedia,
            smartPaySetting:merchant.smartpaySetting,
            xSpSessionID:headers['x-sp-session-id'],
            tipping,
            roundingRule: merchant.roundingRule,
            splitPayment: setting.splitPayment,
            checkoutSetting: {
                publicKey: checkoutSetting?.publicKey
            },
            googlePaySetting: {
                baseCardPaymentMethod:googlePaySetting?.baseCardPaymentMethod,
                baseRequest:googlePaySetting?.baseRequest,
                baseUrl:googlePaySetting?.baseUrl,
                gatewayMerchantId:googlePaySetting?.gatewayMerchantId,
                googleMerchantName:googlePaySetting?.googleMerchantName,
                googlePayEnv:googlePaySetting?.googlePayEnv,
                googlePaymentType:googlePaySetting?.googlePaymentType,
                googleTokenType:googlePaySetting?.googleTokenType,
                invokeUrl:googlePaySetting?.invokeUrl,
                mode:googlePaySetting?.mode,
                publicKey:googlePaySetting?.publicKey,
                tokenizationSpecification:googlePaySetting?.tokenizationSpecification
            },
            applePaySetting: applePaySetting,
            platformFee: setting.platformFee
        }
    }   
}


export default new LandingPageService();